import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

const barColor = {
  primary: "bg-primary",
  teal: "bg-teal",
  blue: "bg-blue",
  secondary: "bg-secondary",
};

export function BloomProgress({
  value = 0,
  color = "primary",
  label,
  showValue = false,
  className,
}) {
  const clamped = Math.max(0, Math.min(100, value));

  return (
    <div className={cn("w-full", className)}>
      {(label || showValue) && (
        <div className="mb-2 flex items-center justify-between">
          {label && <span className="text-sm font-bold text-foreground">{label}</span>}
          {showValue && <span className="text-sm font-bold text-muted-foreground">{clamped}%</span>}
        </div>
      )}
      <div
        className="relative h-4 w-full overflow-hidden rounded-full bg-muted"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label || "progress"}
      >
        <motion.div
          className={cn("h-full rounded-full", barColor[color])}
          initial={{ width: 0 }}
          whileInView={{ width: `${clamped}%` }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.34, 1.56, 0.64, 1] }}
        />
      </div>
    </div>
  );
}

export default BloomProgress;
